<template>
    <div class="full-height">
        <div id="bookingForm" class="cbs-booking-form booking-container thin-scroll">
            <form action="#" novalidate vv-on:submit="bookingFormSubmit" class="booking-form mb-0">
                <div class="booking-type-tabs">
                    <ul class="nav nav-tabs nav-fill">
                        <li class="nav-item">
                            <a class="nav-link" v-bind:class="{ active: !isHourlyBooking }" v-on:click="bookingTypeChanged(1)">
                                <span>TRANSFER</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" v-bind:class="{ active: isHourlyBooking }" v-on:click="bookingTypeChanged(2)">HOURLY</a>
                        </li>
                    </ul>
                </div>

                <div class="form-group mt-20">
                    <div class="input-group mb-2">
                        <vue-google-autocomplete id="bookingPickupLocation" name="pickupLocation"
                                                 classname="form-control" placeholder="Pickup address or airport"
                                                 :country="getAutocompleteCountry" v-model="pickupLocation">
                        </vue-google-autocomplete>
                    </div>
                    <div v-if="showErrors">
                        <div class="error-message" v-if="!this.pickupLocation.location">Please select pickup location.</div>
                    </div>
                </div>
                <div class="form-group mt-20" v-show="!isHourlyBooking">
                    <div class="input-group mb-2">
                        <vue-google-autocomplete id="bookingDrpoffLocation" name="bookingDrpoffLocation"
                                                 classname="form-control" placeholder="Drop-off address or airport"
                                                 :country="getAutocompleteCountry" v-model="dropoffLocation">
                        </vue-google-autocomplete>
                    </div>
                    <div v-if="showErrors">
                        <div class="error-message" v-if="!this.isHourlyBooking && !this.dropoffLocation.location">Please select drop-off location.</div>
                    </div>
                </div>
                <!--v-model="bookingDuration" v-bindinput="handleSelect(box.id, $event)" -->
                <div class="form-group" v-show="isHourlyBooking">
                    <div class="input-group full-row mb-2">
                        <select class="form-control" v-bind:class="{ notSelected: bookingDuration == 0 }" v-model="bookingDuration">
                            <option v-for="option in bookingAllowedDurations" v-bind:value="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                    </div>
                    <div v-if="showErrors">
                        <div class="error-message" v-if="this.isHourlyBooking && !this.bookingDuration">Please select number of hours.</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <vue-date-picker v-model="pickupDate" id="bookingPickupDate" name="bookingPickupDate"
                                         type="text" class="form-control"
                                         style="border-radius: 0;" placeholder="Day">
                        </vue-date-picker>
                        <div v-if="showErrors">
                            <div class="error-message" v-if="!this.pickupDate">Pickup date is required.</div>
                        </div>
                    </div>
                    <div class="col-6">
                        <vue-time-picker v-model="pickupTime" id="bookingPickupTime" type="text" class="form-control" placeholder="Time">
                        </vue-time-picker>
                        <div v-if="showErrors">
                            <div class="error-message" v-if="!this.pickupTime">Pickup time is required.</div>
                        </div>
                    </div>
                </div>
                <div class="row mb-0" v-if="this.errors.length > 0">
                    <div class="col">
                        <ul class="list-unstyled error mb-0">
                            <li v-for="item in this.errors" :key="item" v-html="item"></li>
                        </ul>
                    </div>
                </div>
                <div class="row mt-10" v-if="this.isNotCoveredPickup">
                    <div class="col text-center">
                        <span v-show="this.showCallOnNotCoveredPickup">
                            <a class="btn btn-sm btn-info" :href="contactPhoneNumberHref">Call {{contactPhoneNumber}}</a> OR
                        </span>
                        <button class="btn btn-sm btn-success" type="button" href="#" @click="$store.commit('setShowContactForm', true)">Ask For Quote</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center">
                        <button type="button" class="btn btn-primary" v-on:click="goToNextStep()">
                            <span v-show="this.isPriceLoading"><i class="fa fa-spinner fa-spin"></i></span>
                            Check Price
                        </button>
                    </div>
                </div>
            </form>
        </div>       
    </div>
</template>
<script>
    import VueGoogleAutocomplete from "../components/vue-google-autocomplete/vue-google-autocomplete.vue";
    import VueDatePicker from "../components/vue-pickadate/pickadate.vue";
    import VueTimePicker from "../components/vue-pickadate/pickatime.vue";

    import Vuelidate from 'vuelidate';
    import { required, email } from 'vuelidate/lib/validators';
    import Vue from "vue";

    Vue.use(Vuelidate);

    export default {        
        name: "BookingForm",
        components: { VueGoogleAutocomplete, VueDatePicker, VueTimePicker },
        beforeCreate: function() { },
        data: function () {
            return {
                showContactModal: false,
                showErrors: false
            };
        },
        validations: {
            pickupLocation: { required },
        },
        computed: {
            showCallOnNotCoveredPickup: function () {
                return this.$store.state.configuration.showCallOnNotCoveredPickup;
            },
            contactPhoneNumber: function () {
                return this.$store.state.configuration.contactPhone;
            },
            contactPhoneNumberHref: function () {
                return 'tel: +' + this.contactPhoneNumber;
            },
            getAutocompleteCountry: function() {
                return this.$store.state.configuration.country;
            },
            isHourlyBooking: function () {
                return this.$store.state.bookingInfo.general.bookingType === 2;
            },
            isNotCoveredPickup: function () {
                return this.$store.getters.isNotCoveredLocation;
            },
            bookingAllowedDurations: function () {
                return this.$store.state.configuration.bookingDurations;
            },
            pickupLocation:  {
                get: function () {
                    return this.$store.state.bookingInfo.general.pickupAddress;
                },
                set: function (newValue) {
                    this.$store.commit('setPickupLocation', newValue);
                }
            },
            dropoffLocation: {
                get: function () { return this.$store.state.bookingInfo.general.dropOffAddress; },
                set: function (value) { this.$store.commit('setDropoffLocation', value); }
            },
            pickupDate: {
                get: function() {
                    return this.$store.state.bookingInfo.general.pickupDate;
                },
                set: function (value) {
                    this.$store.commit('setPickupDate', value);
                }
            },
            pickupTime: {
                get: function () {
                    return this.$store.state.bookingInfo.general.pickupTime;
                },
                set: function (value) {
                    this.$store.commit('setPickupTime', value);
                }
            },
            bookingDuration: {
                get: function () {
                    return this.$store.state.bookingInfo.general.durationInHours;
                },
                set: function (newValue) {
                    this.$store.commit('setDurationInHours', newValue);
                }
            }, 
            isPriceLoading: function () { return this.$store.state.bookingInfo.general.isPriceLoading; },
            errors: function () { return this.$store.state.bookingInfo.general.serverPriceErrors; }
        },
        methods: {
            isBookingFormValid: function () {
                var isValid = true;

                //every booking should have pickup location, date & time
                if (!this.pickupLocation.location || !this.pickupDate || !this.pickupTime) isValid = false;

                //check to have duration for hourly bookings
                if (this.isHourlyBooking && !this.bookingDuration) isValid = false;
                if (!this.isHourlyBooking && !this.dropoffLocation.location) isValid = false;

                return isValid;
            },
            goToNextStep: function () {
                //TODO: check if form is valid ... 
                var isValid = this.isBookingFormValid();
                if (!isValid) {
                    this.showErrors = true; //showErrors();
                    return;
                }
                //console.log('save and redirect');
                //this.$store.dispatch('saveStateAndGoToBookingPage');
                this.$store.commit('setNextRedirect', '/booking')
                this.$store.dispatch('getBookingPrice');
              //  this.$store.dispatch('goToNextStep');
            },
            bookingTypeChanged: function (data) {
                this.$store.commit('setBookingType', data);
            },
            //bookingDurationChanged: function (ev, data) {
            //    this.$store.commit('setDurationInHours', data);
            //}
        }
    };
</script>

<style>
    .cbs-booking-form .list-unstyled.error {
        color: #e25950;
        text-align: center;
        margin-bottom: 20px;
    }
</style>